export default "__VITE_ASSET__C2G2zNKg__"